export default (timestamp: number): string => new Date(timestamp).toISOString();
